module.exports = __webpack_public_path__ + "img/_ionicons_svg_md-settings.316c417e.svg";